var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.601 42",
    enableBackground: "new 0 0 42.601 42",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCD40",
    points: "14.6,0 0,0 0,14.6 4.54,14.6 4.54,7.75 14.12,17.33 17.33,14.12 7.75,4.54 14.6,4.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCD40",
    points: "34.852,4.54 25.272,14.12 28.482,17.33 38.062,7.75 38.062,14.6 42.601,14.6 42.601,0 28.002,0  28.002,4.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCD40",
    points: "28.002,42 42.601,42 42.601,27.4 38.062,27.4 38.062,34.25 28.482,24.671 25.272,27.88  34.852,37.46 28.002,37.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCD40",
    points: "4.54,27.4 0,27.4 0,42 14.6,42 14.6,37.46 7.75,37.46 17.33,27.88 14.12,24.671 4.54,34.25  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.ddf7184cf31988b3cb7923f289c1a1be.svg";
export { ForwardRef as ReactComponent };